"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamCard = exports.RecordStream = exports.ErrorText = exports.ContentHeader = exports.ContentBody = exports.Container = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var StreamCard = function StreamCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    Icon = _ref.Icon,
    _ref$css = _ref.css,
    css = _ref$css === void 0 ? {} : _ref$css,
    onClick = _ref.onClick,
    testId = _ref.testId;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: _objectSpread({
      w: "100%",
      p: "$10",
      r: "$1",
      cursor: "pointer",
      bg: "$surfaceLight",
      mb: "$10",
      mt: "$8"
    }, css),
    "data-testid": testId,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        alignSelf: "center",
        p: "$4"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        width: 40,
        height: 40
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
      css: {
        flex: "1 1 0",
        mx: "$8"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "h6",
        css: {
          mb: "$4"
        },
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "sm",
        css: {
          color: "$textMedEmp"
        },
        children: subtitle
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        alignSelf: "center"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronRightIcon, {})
    })]
  });
};
exports.StreamCard = StreamCard;
var ContentHeader = function ContentHeader(_ref2) {
  var onBack = _ref2.onBack,
    title = _ref2.title,
    content = _ref2.content;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      w: "100%",
      py: "$8",
      px: "$10",
      cursor: "pointer"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        p: "$2",
        bg: "$surfaceLight",
        r: "$round",
        alignSelf: "center"
      },
      onClick: onBack,
      "data-testid": "go_back",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronLeftIcon, {
        width: 16,
        height: 16
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
      css: {
        flex: "1 1 0",
        mx: "$8"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "sm",
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "h6",
        children: content
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      onClick: onBack,
      css: {
        alignSelf: "flex-start"
      },
      "data-testid": "close_stream_section",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {
        width: 16,
        height: 16
      })
    })]
  });
};
exports.ContentHeader = ContentHeader;
var Container = function Container(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      size: "100%",
      zIndex: 2,
      position: "absolute",
      top: 0,
      left: 0,
      bg: "$surfaceDefault",
      transform: "translateX(10%)",
      animation: "".concat((0, _reactUi.slideLeftAndFade)("10%"), " 100ms ease-out forwards"),
      display: "flex",
      flexDirection: "column"
    },
    children: children
  });
};
exports.Container = Container;
var ContentBody = function ContentBody(_ref4) {
  var Icon = _ref4.Icon,
    title = _ref4.title,
    children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      p: "$10"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
      css: {
        display: "flex",
        alignItems: "center",
        mb: "$4"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        as: "span",
        css: {
          fontWeight: "$semiBold",
          ml: "$4"
        },
        children: title
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sm",
      css: {
        color: "$textMedEmp"
      },
      children: children
    })]
  });
};
exports.ContentBody = ContentBody;
var RecordStream = function RecordStream(_ref5) {
  var record = _ref5.record,
    setRecord = _ref5.setRecord,
    testId = _ref5.testId;
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  return permissions !== null && permissions !== void 0 && permissions.browserRecording ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      bg: "$surfaceLight",
      m: "$8 $10",
      p: "$8",
      r: "$0"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        color: "$error"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.RecordIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "sm",
      css: {
        flex: "1 1 0",
        mx: "$8"
      },
      children: "Record the stream"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Switch, {
      checked: record,
      onCheckedChange: setRecord,
      "data-testid": testId
    })]
  }) : null;
};
exports.RecordStream = RecordStream;
var ErrorText = function ErrorText(_ref6) {
  var error = _ref6.error;
  if (!error) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
    variant: "sm",
    css: {
      mb: "$8",
      color: "$error"
    },
    children: error
  });
};
exports.ErrorText = ErrorText;